import React from 'react';
import { Link } from 'react-router-dom';
export const VIRIDIA_LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/pyokADniAsh12NgS1hG2fJ/VA-Logo_(1).png';
interface BrandProps {
  logoClassName?: string;
  wordmarkClassName?: string;
}
export function Brand({
  logoClassName = 'h-[54px] w-auto',
  wordmarkClassName = 'text-lg sm:text-xl'
}: BrandProps) {
  return <Link to="/" className="flex items-center gap-3 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-31" data-mp="1faqj7nejzl3w">
      <img src={VIRIDIA_LOGO_SRC} alt="Viridia Analytics" className={logoClassName} loading="eager" data-id="element-32" data-mp="nmyji9nxrmjf" />
      <span className={`font-display font-semibold tracking-tight text-white ${wordmarkClassName}`} data-id="element-33" data-mp="rle5ca8a6ov9">
        Viridia<span className="text-brand" data-id="element-34" data-mp="3w1yrbhzqzyfp"> Analytics</span>
      </span>
    </Link>;
}